// import * as XLSX from "xlsx";
// import { toast } from "react-toastify";

// const ExportToExcel = (cleanedLeads,filename) => {
//   try {
//     const jsonData = JSON.stringify(cleanedLeads, null, 2);
//     const worksheet = XLSX.utils.json_to_sheet(JSON.parse(jsonData));
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Leads");
//     XLSX.writeFile(workbook, `${filename}.xlsx`);
//     toast("Data Exported Successfully");
//   } catch (error) {
//     console.error("Error:", error);
//   }
// };

// export default ExportToExcel;

import * as XLSX from "xlsx";
import { toast } from "react-toastify";

const ExportToExcel = (cleanedLeads, filename = "ExportedData") => {
  // Added default filename
  try {
    // No need to stringify and parse - we can use the data directly
    const worksheet = XLSX.utils.json_to_sheet(cleanedLeads);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Leads");
    XLSX.writeFile(workbook, `${filename}.xlsx`);
    toast.success("Data Exported Successfully"); // Updated to use toast.success
  } catch (error) {
    console.error("Error exporting to Excel:", error);
    toast.error("Error exporting data");
  }
};

export default ExportToExcel;
